module.exports = __webpack_public_path__ + "static/media/turkey.d0f1a695.svg";